// Offline-Hilfsfunktionen und Typen.
//
// Wave 14bd: dieses Modul HAT früher die PMTiles-Caching-Logik über die
// CacheStorage-API gehostet (downloadToCache, getCacheStatus,
// removeFromCache, clearAllOfflineData). Seit 14bd leben die gleichen
// Funktionen in `./opfsStore.ts` — das Storage-Backend ist jetzt OPFS
// (FileSystemDirectoryHandle). Siehe Wave-14bd-Kommentare in pmtiles.ts und
// opfsStore.ts für die Gründe (iOS-Safari CacheStorage-Blob-Latency +
// Vary/Range-Unreliability bei grossen Dateien).
//
// Was hier übrig bleibt: ein paar rein-helferige Sachen (Bytes-Formatter,
// Storage-Estimate) und die Typ-Definitionen, die von mehreren Call-Sites
// genutzt werden. Keine Storage-Writes in diesem Modul mehr.

// Wave 14cf: `key` von Discriminated-Union auf string gelockert. Vorher
// reichten 3 feste Werte (map/contours/hillshade), seit Multi-Region nutzen
// Cards Keys wie "elba:contours" um Region+Layer in einer Section zu
// disambiguieren. Lokale Logik die zwischen den 3 Layer-Typen unterscheiden
// muss, soll dafür ein eigenes (typed) Field bekommen — `key` ist nur
// noch React-Render-Identität.
export type OfflineFileLayer = 'map' | 'contours' | 'hillshade';

export interface OfflineFile {
  key: string;
  title: string;
  description: string;
  url: string;
  sizeBytes: number;
}

export interface DownloadProgress {
  loaded: number;
  total: number;
  percent: number;
}

/**
 * Gesamter Storage-Verbrauch (grobe Info fürs UI). `navigator.storage.estimate`
 * gibt Quota + Usage in Bytes. Auf iOS Safari ist die Quota ein dynamischer
 * Wert (Device-Space-abhängig), deshalb kein fester Vergleich möglich.
 */
export async function getStorageEstimate(): Promise<{ usage: number; quota: number } | null> {
  if (!('storage' in navigator) || !navigator.storage.estimate) return null;
  const est = await navigator.storage.estimate();
  return { usage: est.usage ?? 0, quota: est.quota ?? 0 };
}

export function formatBytes(bytes: number): string {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}
